import type { UserPreferencesNotificationsMenuItemOptions } from "./user-preferences-notifications-dropdown.type";
import type { UserPreferencesNotificationsAction } from "../user-preferences-notifications.type";
import type { NotificationsChannelType } from "@/entities/referential/referential-notifications";
import type { MenuItemProps } from "antd";

export const getMenuItemActionOptions = (
  menuItem: MenuItemProps
): UserPreferencesNotificationsMenuItemOptions | undefined => {
  const action =
    "action" in menuItem && typeof menuItem.action === "string"
      ? (menuItem.action as UserPreferencesNotificationsAction)
      : undefined;

  if (!action) return undefined;

  const channel =
    "channel" in menuItem && typeof menuItem.channel === "string"
      ? (menuItem.channel as NotificationsChannelType)
      : undefined;

  return {
    action,
    channel,
  };
};
